import { Route } from 'react-router-dom'

// Layout
import MonitorLayout from '../layout/MonitorLayout'

// Pages
import AdminDashboardPage from '../pages/admin/AdminDashboardPage'

// Guards
import ProtectedRoute from '../core/guards/ProtectedRoute'
import { AppRoute } from '../core/config/app-routes'
import SettingsPage from '@/pages/business/SettingsPage'

export default function MonitorRoutes() {
    return (
        <>
            <Route
                path={AppRoute.MONITOR_DASHBOARD_ROUTE}
                element={
                    <ProtectedRoute>
                        <MonitorLayout>
                            <AdminDashboardPage />
                        </MonitorLayout>
                    </ProtectedRoute>
                }
            />

            {/* Settings */}
            <Route
                path={AppRoute.MONITOR_SETTINGS_ROUTE}
                element={
                    <ProtectedRoute>
                        <MonitorLayout>
                            <SettingsPage />
                        </MonitorLayout>
                    </ProtectedRoute>
                }
            />
        </>
    )
}

